import Translate from "../../../../translation/utils/translateFunction";
import { CustomTitleCellRender } from "../../../common/CustomCellRender";

export const getManagerColumns = (customCellRender) => {
  const columns = [
    {
      field: "serialNumber",
      headerName: Translate("addManager:srNoTableHeading"),
      align: "center",
      headerAlign: "center",
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: "name",
      headerName: Translate("addManager:nameTableHeading"),
      minWidth: 250,
      maxWidth: 250,
      sortable: true,
      disableColumnMenu: true,
      renderCell: (params) => CustomTitleCellRender(params?.row?.name),
    },
    {
      field: "mobile",
      headerName: Translate("addManager:mobileTableHeading"),
      minWidth: 250,
      maxWidth: 250,
      sortable: true,
      disableColumnMenu: true,
    },
    {
      field: "companyName",
      headerName: Translate("addManager:companyNameTableHeading"),
      minWidth: 250,
      maxWidth: 250,
      sortable: true,
      disableColumnMenu: true,
      renderCell: (params) => CustomTitleCellRender(params?.row?.companyName),
    },
    {
      field: "email",
      headerName: Translate("addManager:emailTableHeading"),
      minWidth: 250,
      maxWidth: 250,
      sortable: true,
      disableColumnMenu: true,
      renderCell: (params) => CustomTitleCellRender(params?.row?.email),
    },
    {
      field: "Action",
      headerName: Translate("addManager:actionTableHeading"),
      minWidth: 250,
      maxWidth: 250,
      sortable: false,
      disableColumnMenu: true,
      renderCell: customCellRender,
    },
  ];
  return columns;
};
